module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4yMDIiIGhlaWdodD0iMTMuMDEiIHZpZXdCb3g9IjAgMCAxNi4yMDIgMTMuMDEiPgogICAgPGcgaWQ9InByZWZpeF9fcmVwbHktYXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMuNDMpIj4KICAgICAgICA8cGF0aCBpZD0icHJlZml4X19QYXRoXzIxNTciIGQ9Ik0xNi4yIDExLjA0djUuNGE1LjE1NiA1LjE1NiAwIDAgMC01LjE1Ni01LjE1NWgtNS41MnYzLjE5MkwwIDguOTUyIDUuNTI0IDMuNDN2Mi40NTNoNS41MjFBNS4xNTggNS4xNTggMCAwIDEgMTYuMiAxMS4wNHoiIGRhdGEtbmFtZT0iUGF0aCAyMTU3IiBzdHlsZT0iZmlsbDojYTlhOWE5Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/message-reply-arrow.svg
// module id = jRy6
// module chunks = 0